module.exports = {"id":"236699","name":"Saša Lukić","rating":"72","photo":"./data/images/photos/3/236699.png","club":{"name":"Levante UD","logo":"./data/images/clubs/LevanteUD.png"},"positions":["MDC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SasaLukic0.json
// module id = 3835
// module chunks = 0